// import { ImagePortraitProps } from '@touche-lts/panel-ui/dist'
// import iconImage from '@touche-lts/panel-ui/dist/assets/svg/icon-image.svg'

export * from './types'
// export const getMainImageSrcForObj = (object: any) => {
//   if (!object) return null
//   if (object.imageUrl) return object.imageUrl
//   if (object.mainImage) return object.mainImage.url
//   if (object.image) return object.image.url
//   if (object.images && object.images.length) return object.images[0].url
// }

// export const secureString = (value: string): string => {
//   if (!value || !value.length) return ''

//   return Array(value.length)
//     .fill('*')
//     .join('')
// }

// export const getImagePortraitProps = (
//   imageUrl: string,
//   noImagePreset: 'person' | 'image'
// ): ImagePortraitProps => {
//   if (imageUrl) {
//     return {
//       src: imageUrl
//     }
//   }

//   switch (noImagePreset) {
//     case 'image': {
//       return {
//         src: iconImage,
//         style: {
//           objectFit: 'none',
//           backgroundColor: '#ccccccb3',
//           opacity: 0.6
//         }
//       }
//     }
//     case 'person': {
//       return {
//         src: undefined,
//         style: {
//           // objectFit: 'none',
//           backgroundColor: '#cccccc70'
//           // opacity: 0.6
//         }
//       }
//     }
//   }
// }

// export const parseToNumberOrNull = (value: any): number => {
//   if (!value) return null

//   let numValue: number = null
//   try {
//     numValue = Number(value)
//     if (isNaN(numValue)) {
//       throw new Error(`ID ${numValue} in not a number`)
//     }
//   } catch (error) {
//     numValue = null
//     console.error(error)
//   } finally {
//     return numValue
//   }
// }

// export const parseStringToNumberAndApplyOnChange = (args: {
//   showError: (msg: string) => void
//   onChange: (value: number) => void
// }) => (stringValue: string) => {
//   const { showError, onChange } = args

//   if (!stringValue) {
//     onChange(null)
//     return
//   }
//   try {
//     const numValue = Number(stringValue)
//     if (!numValue || isNaN(numValue)) {
//       throw new Error(`ID ${stringValue} is not a valid number`)
//     }

//     onChange(numValue)
//   } catch (error) {
//     console.error(error)
//     showError(`ID ${stringValue} is not a valid number`)
//   }
// }

// export const toLowerCaseTrimmed = (value: string): string => {
//   if (!value) return ''
//   return value.trim().toLowerCase()
// }


export const getLogoImageSrcForObj = (object: any): string => {
    if (!object) return null
    if (object.mainImage) return object.mainImage.url
    return (object.images || []).find(img => img.mainImage)?.url
}

export const getBackgroundImageSrcForObj = (object: any): string => {
    if (!object) return null
    // if (object.mainImage) return object.mainImage.url
    return (object.images || []).find(img => img.backgroundImage)?.url
}

export const generateLocalId = (): number => {
    return Number(0 + '.' + new Date().getMilliseconds())
}

export const isLocalId = (id: number): boolean => {
    return id < 1
}

export const getSelectOptions = (object: any): any => {
    return Object.values(object).map(type => ({
        label: type,
        value: type
    }))
}

export const formatNumberShort = (
  value: number | string,
  digits: number = 2
): string => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '0'
  }

  const num = Number(value)
  const absolute = Math.abs(num)
  const units = [
    { limit: 1e12, suffix: 'T' },
    { limit: 1e9, suffix: 'B' },
    { limit: 1e6, suffix: 'M' },
    { limit: 1e3, suffix: 'K' }
  ]

  const format = (v: number, suffix = '') => {
    const fixed = v.toFixed(digits)
    const trimmed = fixed.replace(/\.?0+$/, '') // keep up to `digits` decimals
    return `${trimmed}${suffix}`
  }

  for (const unit of units) {
    if (absolute >= unit.limit) {
      return format(num / unit.limit, unit.suffix)
    }
  }

  return format(num)
}
